/* export const myMutation = (state)=> {} */

export const digitalLettersSearch = (state, payload) => {
    state.digitalLetters.search = {
        ...state.digitalLetters.search,
        ...payload
    };
}

export const salesUsers = (state, payload) => {
    state.salesUsers = {
        ...state.salesUsers,
        ...payload
    };
}

export const salesUsersForm = (state, payload) => {
    state.salesUsers.form = {
        ...state.salesUsers.form,
        ...payload
    };
}
